import React from 'react';

const HamburgerDragIcon = () => (
    <div className='drag-icon'>
        <div></div>
        <div></div>
        <div></div>
    </div>
);

export default HamburgerDragIcon;